import { CommonEnums } from 'src/app/shared/common.enums';

export class LAttribute {
	lAttr_Id: number;
	obj_Id: number;
	lAttrNm: string;
	lnk_Attr_Id: number;
	dTyp_Attr_Id: number;
	distKeyFlag: number;
	srt_Order: number;
	lnk_Obj_Inst_Id: number;
	orgKeyFlag: number;
	upiFlag: number;
	usiFlag: number;
	nupiFlag: number;
	nusiFlag: number;
	orderBy: number;
	dxMp_Id: number;
	valid_Cd: string;
	ref_Id: number;
	ref_Cd: string;
	lattrPrec: number;
	lattrScale: number;
	lattrExpVal: string;
	clusterFlag: number;
	partitionflag: number;
	maxFlag: string;
	isMaxEditFlag: string; 
	function: string;
	type: string;

	constructor() {
		this.setDefaults()
	}

	setDefaults(): void {
		this.lAttr_Id = CommonEnums.defaults.LONG_VAL;
		this.obj_Id = CommonEnums.defaults.LONG_VAL;
		this.lnk_Attr_Id = CommonEnums.defaults.LONG_VAL;
		this.dTyp_Attr_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
		this.lAttrNm = CommonEnums.defaults.STRING_EMPTY;
		this.distKeyFlag = CommonEnums.defaults.NUM_VAL;
		this.srt_Order = CommonEnums.defaults.LONG_VAL;
		this.lnk_Obj_Inst_Id = CommonEnums.defaults.LONG_VAL;
		this.ref_Id = CommonEnums.defaults.LONG_VAL;
		this.orgKeyFlag = CommonEnums.defaults.NUM_VAL;
		this.upiFlag = CommonEnums.defaults.NUM_VAL;
		this.usiFlag = CommonEnums.defaults.NUM_VAL;
		this.nupiFlag = CommonEnums.defaults.NUM_VAL;
		this.nusiFlag = CommonEnums.defaults.NUM_VAL;
		this.orderBy = CommonEnums.defaults.NUM_VAL;
		this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
		this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
		this.lattrPrec = CommonEnums.defaults.DEFAULT_INT_VAL;
		this.lattrScale = CommonEnums.defaults.DEFAULT_INT_VAL;
		this.lattrExpVal = CommonEnums.defaults.STRING_EMPTY;
		this.clusterFlag = CommonEnums.defaults.NUM_VAL;
		this.partitionflag = CommonEnums.defaults.NUM_VAL;
		this.maxFlag = CommonEnums.defaults.STRING_EMPTY;
		this.isMaxEditFlag = CommonEnums.defaults.STRING_EMPTY;
		this.type = 'Group';
		this.function = CommonEnums.defaults.STRING_EMPTY;
	}

	static parse(lAttributeTmp: LAttribute): LAttribute {
		let lAttribute: LAttribute = new LAttribute();
		lAttribute.copyFrom(lAttributeTmp);
		return lAttribute;
	}

	getPrimaryKey(): string {
		return this.dxMp_Id + '.' + this.obj_Id + '.' + this.lAttr_Id;
	}

	copy(): LAttribute {
		let lAttributeTmp: LAttribute = new LAttribute();

		lAttributeTmp.lAttr_Id = this.lAttr_Id;
		lAttributeTmp.obj_Id = this.obj_Id;
		lAttributeTmp.lAttrNm = this.lAttrNm;
		lAttributeTmp.lnk_Attr_Id = this.lnk_Attr_Id;
		lAttributeTmp.dTyp_Attr_Id = this.dTyp_Attr_Id;
		lAttributeTmp.distKeyFlag = this.distKeyFlag;
		lAttributeTmp.srt_Order = this.srt_Order;
		lAttributeTmp.lnk_Obj_Inst_Id = this.lnk_Obj_Inst_Id;
		lAttributeTmp.orgKeyFlag = this.orgKeyFlag;
		lAttributeTmp.upiFlag = this.upiFlag;
		lAttributeTmp.usiFlag = this.usiFlag;
		lAttributeTmp.nupiFlag = this.nupiFlag;
		lAttributeTmp.nusiFlag = this.nusiFlag;
		lAttributeTmp.orderBy = this.orderBy;
		lAttributeTmp.dxMp_Id = this.dxMp_Id;
		lAttributeTmp.valid_Cd = this.valid_Cd;
		lAttributeTmp.ref_Id = this.ref_Id;
		lAttributeTmp.ref_Cd = this.ref_Cd;
		lAttributeTmp.lattrPrec = this.lattrPrec;
		lAttributeTmp.lattrScale = this.lattrScale;
		lAttributeTmp.lattrExpVal = this.lattrExpVal;
		lAttributeTmp.clusterFlag = this.clusterFlag;
		lAttributeTmp.partitionflag = this.partitionflag;
		lAttributeTmp.maxFlag = this.maxFlag;
		lAttributeTmp.isMaxEditFlag = this.isMaxEditFlag;
		lAttributeTmp.type = this.type;
		lAttributeTmp.function = this.function;

		return lAttributeTmp;
	}

	copyFrom(lAttributeTmp: LAttribute): void {
		this.lAttr_Id = lAttributeTmp.lAttr_Id;
		this.obj_Id = lAttributeTmp.obj_Id;
		this.lAttrNm = lAttributeTmp.lAttrNm;
		this.lnk_Attr_Id = lAttributeTmp.lnk_Attr_Id;
		this.dTyp_Attr_Id = lAttributeTmp.dTyp_Attr_Id;
		this.distKeyFlag = lAttributeTmp.distKeyFlag;
		this.srt_Order = lAttributeTmp.srt_Order;
		this.lnk_Obj_Inst_Id = lAttributeTmp.lnk_Obj_Inst_Id;
		this.orgKeyFlag = lAttributeTmp.orgKeyFlag;
		this.upiFlag = lAttributeTmp.upiFlag;
		this.usiFlag = lAttributeTmp.usiFlag;
		this.nupiFlag = lAttributeTmp.nupiFlag;
		this.nusiFlag = lAttributeTmp.nusiFlag;
		this.orderBy = lAttributeTmp.orderBy;
		this.dxMp_Id = lAttributeTmp.dxMp_Id;
		this.valid_Cd = lAttributeTmp.valid_Cd;
		this.ref_Id = lAttributeTmp.ref_Id;
		this.ref_Cd = lAttributeTmp.ref_Cd;
		this.lattrPrec = lAttributeTmp.lattrPrec;
		this.lattrScale = lAttributeTmp.lattrScale;
		this.lattrExpVal = lAttributeTmp.lattrExpVal;
		this.clusterFlag = lAttributeTmp.clusterFlag;
		this.partitionflag = lAttributeTmp.partitionflag;
		this.maxFlag = lAttributeTmp.maxFlag;
		this.isMaxEditFlag = lAttributeTmp.isMaxEditFlag;
		this.type = lAttributeTmp.type;
		this.function = lAttributeTmp.function;
	}

	compare(lAttributeTmp: LAttribute): string {
		let lAttributeString: string = this.toString(false);
		let lAttributeTmpString: string = lAttributeTmp.toString(false);

		if (lAttributeString != lAttributeTmpString) {
			return lAttributeString + ', ' + lAttributeTmpString;
		}

		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let str: string = "lAttribute [lAttr_Id=" + this.lAttr_Id + ", obj_Id=" + this.obj_Id + ", lAttrNm=" + this.lAttrNm +
			", lnk_Attr_Id=" + this.lnk_Attr_Id + ", dTyp_Attr_Id=" + this.dTyp_Attr_Id + ", distKeyFlag=" + this.distKeyFlag +
			", srt_Order=" + this.srt_Order + ", lnk_Obj_Inst_Id=" + this.lnk_Obj_Inst_Id + ", orgKeyFlag=" + this.orgKeyFlag +
			", upiFlag=" + this.upiFlag + ", usiFlag=" + this.usiFlag + ", nupiFlag=" + this.nupiFlag + ", nusiFlag=" + this.nusiFlag +
			", orderBy=" + this.orderBy + ", dxMp_Id=" + this.dxMp_Id + ", valid_Cd=" + this.valid_Cd + ", ref_Id=" + this.ref_Id +
			", ref_Cd=" + this.ref_Cd + ", lattrPrec=" + this.lattrPrec + ", lattrScale=" + this.lattrScale + ", lattrExpVal=" + this.lattrExpVal +
			", clusterFlag=" + this.clusterFlag + ", partitionflag=" + this.partitionflag + ", maxFlag=" + this.maxFlag +
			", isMaxEditFlag=" + this.isMaxEditFlag + ", type=" + this.type + ", function=" + this.function;

		if (isNotCompare) {
			str += ''
		}

		str += ']';

		return str;
	}
}
